export enum ErrorCode {
    NOT_FOUND = '404 Not Found',
    FAILURE = 'Failure',
}

export type StateShape<T, D extends Record<string, unknown>> = {
    state: T;
} & D;

export enum RequestStateType {
    LOADING = 'loading',
    ERROR = 'error',
    IDLE = 'idle',
}

type RequestStateShape<
    T extends RequestStateType,
    D extends Record<string, unknown> = Record<string, unknown>,
> = StateShape<T, D>;

export type RequestState =
    | RequestStateShape<RequestStateType.LOADING>
    | RequestStateShape<RequestStateType.ERROR, { error: unknown }>
    | RequestStateShape<RequestStateType.IDLE>;
